import React from 'react'
import "./TermsCondition.css"
import { Link, useNavigate } from 'react-router-dom';
function PrivacyPolicy() {
    const navigate = useNavigate();
    const previouseScreen = () => {
        navigate(-1);
    }
    return (
        <div class="container-fluid  global_container BathHeader">
            <div className='p-3'>
                <div className="row mb-2">
                    <div className="col-md-6 col-12">
                        <h2 className="TitleHeader"> Privacy Policy </h2>
                    </div>
                    <div className="col-md-6 col-12 ListBtn">
                        <ul class="List-Button">
                            <li class="ListBtnItems">
                                <Link
                                    to={"javascript:void(0)"}
                                    onClick={previouseScreen}
                                    className="secondaryButton "
                                    variant="secondary"
                                >
                                    Back
                                </Link>
                            </li>


                        </ul>
                    </div>
                </div>
                <div class="">
                    <p>
                        These terms and conditions (hereinafter referred to as Terms) governs the manner in which
                        ANNA IAS ACADEMY (hereinafter referred to as AIASA) collects, uses, maintains and discloses
                        information collected from users of the  <a style={{ fontWeight: "bold", fontSize: "14px" }} href='/'>www.annaiasacademy.com </a> website and the
                        business operation of AIASA.
                    </p>
                    <p>
                        These terms apply to this website, all products and services as offered by AIASA. Users of this
                        website are requested to please read these Terms carefully before using this website, which is
                        operated and owned by AIASA.
                    </p>
                    <p>
                        Your access to and use of this website service is conditioned on your acceptance of and
                        compliance with these Terms. These Terms apply to all visitors, users and others who access or
                        use the services in this website.
                    </p>
                    <p>
                        By registering on this website or by subscribing to a service provided in this website and by
                        providing your contact details, viz Name, Address, Adhaar number telephone number, email,
                        mobile number, shipping address, etc., User hereby give their consent, for the purpose of
                        receiving information about products and services offered by AIASA. User also hereby give their
                        consent that AIASA may contact you in future to provide information regarding its products and
                        services by using the information that they have provide to AIASA.
                    </p>

                    <a href='#' className="subTitleHeader">CHANGES TO THIS PRIVACY POLICY</a>
                    <p className='pt-3'>
                        AIASA BOOK PUBLICATIONS reserve all rights to modify these terms and conditions at any
                        time, users may please review it frequently. Any changes and clarifications brought in the terms will
                        take effect immediately and will be posted on this website. Users who would like to: access, correct,
                        amend or delete any personal identification information AIASA BOOK PUBLICATIONS have about
                        you, may register a complaint, and may contact us via email at  <a style={{ fontWeight: "bold", fontSize: "14px" }} href="mailto:support@annaiasacademy.com" >support@annaiasacademy.com </a>

                    </p>








                </div>
            </div>
        </div>
    )
}

export default PrivacyPolicy;